import clsx from "clsx";
import { Link } from "gatsby";
import React, { FC } from "react";

import { usePageFullPath } from "../../../../hooks/use-page-full-path";
import { Clickable } from "../../../buttons/button/clickable";
import { Cta } from "../../../buttons/cta";

interface Props {
  columnClassName: string;
  product: Queries.ProductDataFragment | null;
  detailOnClick?: () => void;
  labels: Record<string, string | null>;
}

export const ProductComparatorItemCtas: FC<Props> = ({
  columnClassName,
  product,
  detailOnClick,
  labels,
}) => {
  const pageId = product?.standardpage?.[0]?.id;
  const pageUrl = usePageFullPath(pageId);
  return (
    <div
      className={clsx(
        "flex flex-col lg:flex-row lg:justify-center lg:items-center",
        "gap-2 lg:gap-4 py-4 w-fit lg:w-auto lg:px-4",
        columnClassName
      )}
      key={product!.id}
    >
      {pageUrl && (
        <Link to={pageUrl}>
          <Clickable variant="primary" size="sm" className="w-full" onClick={detailOnClick}>
            {labels["product-comparator-detail-details"]}
          </Clickable>
        </Link>
      )}
      {product?.requestInfoFormCta && (
        <Cta
          variant="primary-outline"
          size="sm"
          className="w-full"
          {...product?.requestInfoFormCta}
        />
      )}
    </div>
  );
};
